import { AngBridge } from "./ang.bridge.util";

export abstract class InstanceCount extends AngBridge {
    public static count = 0;
    public instanceId: number;

    constructor() {
        super();
        const counter = this.constructor as typeof InstanceCount;
        counter.count = (counter.count ?? 0) + 1;
        this.instanceId = counter.count;
    }
}

export namespace InstanceCount {
    const prefixes: Record<string, true> = {};

    export function idGenerator({ prefix, startCount = 1 }: { prefix: string; startCount?: number }): () => string {
        let count = startCount;
        if (prefixes[prefix]) {
            throw new Error("This ID prefix has already been claimed", { cause: prefix });
        }
        prefixes[prefix] = true;
        return () => prefix + "_" + count++;
    }
}
